import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './ImpersonationOverlay.css';

const ImpersonationOverlay: React.FC = () => {
    const { isImpersonating, impersonatedRole, stopImpersonation } = useAuth();
    const { t } = useTranslation();

    if (!isImpersonating || !impersonatedRole) {
        return null;
    }

    const getRoleInfo = (role: string) => {
        switch (role) {
            case 'ADMIN':
                return { label: 'Admin User', icon: 'admin_panel_settings', color: '#dc3545' };
            case 'USER':
                return { label: 'Pro User', icon: 'star', color: '#007bff' };
            case 'FREE':
                return { label: 'Free User', icon: 'person', color: '#ffc107' };
            case 'GUEST':
                return { label: 'Guest User', icon: 'visibility', color: '#28a745' };
            default:
                return { label: role, icon: 'person', color: '#6c757d' };
        }
    };

    const roleInfo = getRoleInfo(impersonatedRole);

    return (
        <div className="impersonation-overlay">
            <div className="impersonation-banner">
                <div className="impersonation-info">
                    <span className="material-icons impersonation-icon" style={{ color: roleInfo.color }}>
                        theater_comedy
                    </span>
                    <div className="impersonation-text">
                        <span className="impersonation-label">
                            {t('settings.impersonation.activeTitle')}
                        </span>
                        <span className="impersonation-role" style={{ color: roleInfo.color }}>
                            <span className="material-icons role-icon">{roleInfo.icon}</span>
                            {roleInfo.label}
                        </span>
                    </div>
                </div>
                <button 
                    className="stop-impersonation-btn"
                    onClick={stopImpersonation}
                    title={t('settings.impersonation.stopTesting')}
                >
                    <span className="material-icons">stop</span>
                    <span className="btn-text">{t('settings.impersonation.stopTesting')}</span>
                </button>
            </div>
        </div>
    );
};

export default ImpersonationOverlay; 